import JobStore from '../store/JobStore'
import TourGuideStore from '../store/TourGuideStore'
import ApplicantTrackingSystem from "../store/ApplicantTrackingSystem";
import { safeJsonParse, safeJsonStringify } from '../helper/jsonUtils';

const genericState = {
    logo: '',
    user: null,
    verificationEmail: false,
    job: {},
    job_fields: {},
    schools: [],
    companyId: null,
    company: {}
}

const genericMutations = {
    SET_COMPANY_LOGO(state, payload) {
        state.logo = payload
    },
    CLEAR_VERIFICATION_EMAIL(state, payload) {
        state.verificationEmail = null
        sessionStorage.removeItem('verificationEmail')
    },
    SET_SHOW_VERIFICATION(state, payload = false) {
        state.verificationEmail = payload
        sessionStorage.setItem('verificationEmail', payload)
    },
    SET_LOGGED_IN_USER(state, payload) {
        state.user = payload
        localStorage.setItem('loggedInUser', safeJsonStringify(payload))
    },
    SET_JOB_DETAILS(state, payload) {
        state.job = payload
        state.job_fields = safeJsonParse(payload.form_structure, [])
        sessionStorage.setItem('currentJobDetails', safeJsonStringify(payload))
        sessionStorage.setItem('jobFields', safeJsonStringify(state.job_fields))
    },
    SET_FETCHED_SCHOOLS(state, payload) {
        state.schools = payload
    },
    SET_COMPANY_ID(state, payload) {
        state.companyId = payload
    },
    SET_COMPANY(state, payload) {
        state.company = payload
    },
}

const Store = {
    auth: {
        state: {
            ...genericState
            // others
            // showLoader: true
        },
        mutations: {
            ...genericMutations,
            // others
        },
    },
    applicants: {
        state: {
            ...genericState
            // others
            // showLoader: true
        },
        mutations: {
            ...genericMutations,
            // others
        },
    },
    jobApplication: {
        state: {
            ...genericState,

        },
        mutations: {
            ...genericMutations,
        },
    },
    interviewer: {
        state: {
            ...genericState,
            // others
            // showLoader: true
        },
        mutations: {},
    },
    admin: {
        state: {
            ...genericState,
            ...TourGuideStore.state,
            ...JobStore.state,
            ...ApplicantTrackingSystem.state
            // others
            // showLoader: true
        },
        getters: {
            ...JobStore.getters,
        },
        mutations: {
            ...TourGuideStore.mutations,
            ...JobStore.mutations,
            ...genericMutations,
            ...ApplicantTrackingSystem.mutations

        },
        actions: {
            ...JobStore.actions,
            ...ApplicantTrackingSystem.actions
        }
    },
    playground: {
        state: {
            ...genericState,
            ...TourGuideStore.state,
            ...JobStore.state,
            ...ApplicantTrackingSystem.state
        }
    }
}


export default Store
